import { Box } from "@mui/material";
import { brandingColors } from "../utils";

export default function SocialMediaComponent(): JSX.Element {
  return (
    <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      flexDirection: { xs: "row", md: "row" },
                      justifyContent: "flex-start",
                      color: brandingColors["grey-font"],
                    }}
                  >
                    <a
                      href="https://www.tiktok.com/@123skincarepro"
                      target="_blank"
                    >
                      <img
                        alt=""
                        src="/assets/tiktok.svg"
                        width="18px"
                        style={{ objectFit: "cover", marginRight: "5px" }}
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/123skincare/"
                      target="_blank"
                    >
                      <img
                        alt=""
                        src="/assets/linkedin.svg"
                        width="18px"
                        style={{ objectFit: "cover", marginRight: "5px" }}
                      />
                    </a>
                    <a
                      href="https://www.instagram.com/123skincare.pro/"
                      target="_blank"
                    >
                      <img
                        alt=""
                        src="/assets/instagram-square.svg"
                        width="18px"
                        style={{ objectFit: "cover", marginRight: "5px" }}
                      />
                    </a>
                  </Box>
  )
}